import { AppUtils } from '../../utils/index';
import { AnredeArtApi } from "../generated/InterfacesAnredeArtApi";

export class MembershipPersonalDataModel {
	private geburtsdatum: string;
	private nachname: string;
	private vorname: string;
	private anredeKennzeichen: AnredeArtApi;
	private titel: string;
	private email: string;
	private telefonNummer: string;
	private telefonVorwahl: string;

	get TelefonVorwahl(): string {
		return this.telefonVorwahl;
	}

	set TelefonVorwahl(value: string) {
		this.telefonVorwahl = value;
	}

	get TelefonNummer(): string {
		return this.telefonNummer;
	}

	set TelefonNummer(value: string) {
		this.telefonNummer = value;
	}

	get Email(): string {
		return this.email;
	}

	set Email(value: string) {
		this.email = value;
	}

	get AnredeKennzeichen(): AnredeArtApi {
		return this.anredeKennzeichen;
	}

	set AnredeKennzeichen(value: AnredeArtApi) {
		this.anredeKennzeichen = value;
	}

	get Titel(): string {
		return this.titel;
	}

	set Titel(value: string) {
		this.titel = value;
	}

	get Vorname(): string {
		return this.vorname;
	}

	set Vorname(value: string) {
		this.vorname = value;
	}

	get Nachname(): string {
		return this.nachname;
	}

	set Nachname(value: string) {
		this.nachname = value;
	}

	get Geburtsdatum(): string {
		return this.geburtsdatum;
	}

	set Geburtsdatum(value: string) {
		this.geburtsdatum = value;
	}

	public toString(): string {
		try {
			return JSON.stringify(this);
		} catch (e) {
			return Object.toString.apply(this);
		}
	}

	/**
	 * Creates a new model object and copies the values from the provided data object (or other application model) to the created model.
	 */
	static createFromObject(dataObject: { [key: string]: any }): MembershipPersonalDataModel {
		return AppUtils.Helper.createFromMap(dataObject, MembershipPersonalDataModel);
	}
}